import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  Button,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelActions,
  ExpansionPanelDetails,
  List,
  ListItem,
  Typography,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { deleteCategory } from './therapeuticCategoryServices';
import TherapeuticAreaDialog from '../therapeuticArea/TherapeuticAreaDialog';
import { dialogModes } from '../Constants';

function TherapeuticCategory({
  category,
  editCategory,
  history,
  onDeleteCategory,
}) {
  const [isDialogOpen, toggleDialog] = useState(false);
  const [dialogMode, changeDialogMode] = useState(dialogModes.add);
  const [thrapeuticAreaToEdit, setThrapeuticAreaToEdit] = useState(null);

  const onAreaClick = areaId => {
    history.push(`/therapeuticCategory/${areaId}`);
  };

  return (
    <React.Fragment>
      <TherapeuticAreaDialog
        isDialogOpen={isDialogOpen}
        toggleDialog={toggleDialog}
        dialogMode={dialogMode}
        thrapeuticAreaToEdit={thrapeuticAreaToEdit}
        changeDialogMode={changeDialogMode}
        setThrapeuticAreaToEdit={setThrapeuticAreaToEdit}
        categoryId={category}
      />
      <ExpansionPanel
        style={{
          width: '100%',
        }}
      >
        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
          <Typography variant="h6">{category.name}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelActions>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => onDeleteCategory(category)}
          >
            Delete
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => editCategory(category)}
          >
            Change name
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => toggleDialog(true)}
          >
            Add Category
          </Button>
        </ExpansionPanelActions>
        <ExpansionPanelDetails>
          <List
            style={{
              width: '100%',
            }}
          >
            {category.therapeuticAreas &&
              category.therapeuticAreas.map((area, index) => (
                <ListItem
                  divider
                  button
                  key={area.id + area.name}
                  onClick={() => onAreaClick(area.id)}
                >
                  <Typography variant="subtitle1">{`${index + 1}.  ${
                    area.name
                  }`}</Typography>
                </ListItem>
              ))}
          </List>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </React.Fragment>
  );
}

const mapDispatchToProps = dispatch => ({
  onDeleteCategory: category => dispatch(deleteCategory(category)),
});

export default connect(
  null,
  mapDispatchToProps
)(withRouter(TherapeuticCategory));



// WEBPACK FOOTER //
// ./src/therapeuticCategory/TherapeuticCategory.js